import { Pipe, PipeTransform } from '@angular/core';
import { User } from '../classes/user.class';
import { AuthorisationService } from '../services/auth/authorisation.service';

@Pipe({
    name: 'hasRole',
    standalone: false,
})
export class HasRolePipe implements PipeTransform {
    transform(value: string | string[], user?: User): boolean {
        if (Array.isArray(value)) {
            return AuthorisationService.hasAnyRole(value, user);
        } else {
            return AuthorisationService.hasRole(value, user);
        }
    }
}
